const getConsentId = () => {
    
    switch( process.env.REACT_APP_ENVIRONMENT ) {
        case 'dev' :
            return process.env.REACT_APP_USER_CONSENT_ID_DEV;
        case 'staging' :
            return process.env.REACT_APP_USER_CONSENT_ID_DEV;
        case 'prod':
            return process.env.REACT_APP_USER_CONSENT_ID_PROD;
    }

    throw new Error('ENVIRONMENT variable error.') 
}


export default getConsentId